<template lang="pug">
.fillblank
  Form(:model="question" label-position="right")
    .question-stem
      FormItem
        //- span(style="float:left;width:20px; height:32px; line-height:32px;font-size:14px") 3.
        Input(placeholder="题目内容",v-model='question.stem',:maxlength="50")
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    FormItem
      Collapse(v-model="CollapseValue")
        Panel(v-for="(app,index) in question.metas" :key="app.id" :name="app.id")
          span 一级指标
          a(link="javascript:;" @click.stop="handleDelIndex('Flevel',index)" style="margin-left:50px;") 删除
          template( #content)
            div
              div(style="display:flex;margin-bottom:10px;")
                div(style="flex:3;margin-right:10px;")
                  span.collapseLabel(style="margin-right:10px;") 一级指标名称
                  Input( v-model="app.title" placeholder="请输入一级指标名称" :maxlength="10" style="width: 300px")
                div(style="flex:1")
                  Checkbox( v-model="app.isShowAnswer" @on-change="(v)=>handleChangeSouce(v,app)") 显示答案
                div
                  span 分值
                  InputNumber(:max="100" :min="0" v-model="app.fraction" style="margin-left:8px;" :disabled="app.isShowAnswer")
              Collapse(v-model="CollapseValue")
                Panel(v-for="(val,vkey) in app.children" :key="val.id" :name="val.id")
                  span 二级指标
                  a(link="javascript:;" @click.stop="handleDelIndex('Slevel',index,vkey)" style="margin-left:50px;") 删除
                  template( #content)
                    div
                      div(style="display:flex;margin-bottom:10px;")
                        div(style="flex:3;margin-right:10px;")
                          span.collapseLabel(style="margin-right:10px;") 二级指标名称
                          Input( v-model="val.title" placeholder="请输入指标名称" :maxlength="10" style="width: 300px")
                        div(style="flex:1")
                          Checkbox( v-model="val.isShowAnswer" @on-change="(v)=>handleChangeSouce(v,val)") 显示答案
                        div
                          span 分值
                          InputNumber(:max="100" :min="0" v-model="val.fraction" style="margin-left:8px;" :disabled="val.isShowAnswer")
                      Collapse(v-model="CollapseValue")
                        Panel(v-for="(item,key) in val.children" :name="item.id" :key="item.id")
                          span 三级指标
                          a(link="javascript:;" @click.stop="handleDelIndex('Tlevel',index,vkey,key)" style="margin-left:50px;") 删除
                          template(#content)
                            div
                              div(style="display:flex;margin-bottom:10px;")
                                div(style="margin-right:10px;")
                                  span.collapseLabel(style="margin-right:10px;") 三级指标名称
                                  //- 最大输入改成20个字符，最终需求
                                  Input( v-model="item.title.name" :maxlength="20" placeholder="请输入指标名称" style="width: 300px")
                                div(style="flex:1")
                                  Checkbox(v-model="item.title.isShowAnswer" @on-change="(v)=>handleChangeSouce(v,item.title)") 显示答案
                                div
                                  span 分值
                                  InputNumber(:max="100" :min="0" v-model="item.title.fraction" style="margin-left:8px;" :disabled="item.title.isShowAnswer")
                              div(style="display:flex;justify-content: space-between;margin-bottom:10px;")
                                div(style="margin-right:10px;")
                                  span.collapseLabel(style="margin-right:10px;") 评价值
                                  Input( v-model="item.estimate.name" :maxlength="50" placeholder="请输入内容" style="width: 300px")
                                div(style="flex:1")
                                  Checkbox(v-model="item.estimate.isShowAnswer" @on-change="(v)=>handleChangeSouce(v,item.estimate)") 显示答案
                                div
                                  span 分值
                                  InputNumber(:max="100" :min="0" v-model="item.estimate.fraction" style="margin-left:8px;" :disabled="item.estimate.isShowAnswer")
                              div(style="display:flex;justify-content: space-between;margin-bottom:10px;")
                                div(style="margin-right:10px;flex:5")
                                  span.collapseLabel 权重
                                  InputNumber(:max="100" :min="0" v-model="item.weight.fraction" style="margin-left:8px;")
                                div(style="flex:2.7")
                                  Checkbox(v-model="item.weight.isShowAnswer" @on-change="(v)=>handleChangeSouce(v,item.answer)") 显示答案
                              div(style="display:flex;justify-content: space-between;margin-bottom:10px;")
                                div(style="display:flex")
                                  div(style="margin-right:10px;")
                                    span.collapseLabel 参考答案区间
                                    InputNumber(:max="100" :min="0" v-model="item.answer.start" style="margin-left:8px;")
                                  div(style="margin-right:10px;")
                                    span 到
                                    InputNumber(:max="100" :min="0" v-model="item.answer.end" style="margin-left:8px;")
                                div
                                  span 分值
                                  InputNumber(:max="100" :min="0" v-model="item.answer.fraction" style="margin-left:8px;" :disabled="item.weight.isShowAnswer")
                      Button(style="margin-top:10px;" type="primary" icon="md-add" ghost @click='handleAddIndex("Tlevel",index,vkey)') 添加三级指标
              Button(style="margin-top:10px;" type="primary" icon="md-add" ghost @click='handleAddIndex("Slevel",index)') 添加二级指标
    FormItem
      Button(type="primary" icon="md-add" ghost @click='handleAddIndex("Flevel")') 添加一级指标
</template>

<script>
import iTag from "@/components/common/iTag";
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
export default {
  components: {
    iTag,
    iDelModel,
    isEditTips
  },
  props: ["data", "tableData"],
  data() {
    return {
      question: {
        stem: "",
        metas: [
          {
            title: "",
            isShowAnswer: false,
            fraction: 0,
            id: "a",
            children: [
              {
                id: "z",
                title: "",
                isShowAnswer: false,
                fraction: 0,
                children: [
                  {
                    id: "b",
                    title: {
                      name: "",
                      isShowAnswer: false,
                      fraction: 0
                    },
                    estimate: {
                      name: "",
                      isShowAnswer: false,
                      fraction: 0
                    },
                    weight: {
                      fraction: 0,
                      isShowAnswer: false
                    },
                    answer: {
                      start: 0,
                      end: 0,
                      fraction: 0
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      tipBtnType: "编辑",
      isEditTips: false,
      CollapseValue: []
      // question: {
      //   stem: "",
      //   tips: "",
      //   isShow: false,
      //   metas: [],
      //   scoringKeywords: [],
      //   analysis: "",
      //   score: 0
      // }
    };
  },
  methods: {
    handleChangeSouce(v, souce) {
      if (v) {
        souce.fraction = 0;
      }
    },
    handleAddIndex(isParent, index, vkey) {
      switch (isParent) {
        case "Flevel":
          this.question.metas.push({
            title: "",
            isShowAnswer: false,
            fraction: 0,
            id: Math.floor(Math.random() * 100000000).toString(),
            children: [
              {
                id: Math.floor(Math.random() * 100000000).toString(),
                title: "",
                isShowAnswer: false,
                fraction: 0,
                children: [
                  {
                    id: Math.floor(Math.random() * 100000000).toString(),
                    title: {
                      name: "",
                      isShowAnswer: false,
                      fraction: 0
                    },
                    estimate: {
                      name: "",
                      isShowAnswer: false,
                      fraction: 0
                    },
                    weight: {
                      fraction: 0,
                      isShowAnswer: false
                    },
                    answer: {
                      start: 0,
                      end: 0,
                      fraction: 0
                    }
                  }
                ]
              }
            ]
          });
          break;
        case "Slevel":
          this.question.metas[index].children.push({
            id: Math.floor(Math.random() * 100000000).toString(),
            title: "",
            isShowAnswer: false,
            fraction: 0,
            children: [
              {
                id: Math.floor(Math.random() * 100000000).toString(),
                title: {
                  name: "",
                  isShowAnswer: false,
                  fraction: 0
                },
                estimate: {
                  name: "",
                  isShowAnswer: false,
                  fraction: 0
                },
                weight: {
                  fraction: 0,
                  isShowAnswer: false
                },
                answer: {
                  start: 0,
                  end: 0,
                  fraction: 0
                }
              }
            ]
          });
          break;
        default:
          this.question.metas[index].children[vkey].children.push({
            id: Math.floor(Math.random() * 100000000).toString(),
            title: {
              name: "",
              isShowAnswer: false,
              fraction: 0
            },
            estimate: {
              name: "",
              isShowAnswer: false,
              fraction: 0
            },
            weight: {
              fraction: 0,
              isShowAnswer: false
            },
            answer: {
              start: 0,
              end: 0,
              fraction: 0
            }
          });
      }
    },
    handleDelIndex(isParent, index, childrenKey, Tkey) {
      this.$Modal.confirm({
        title: "删除",
        content: "<p>删除后不可恢复，确认要删除吗？</p>",
        onOk: () => {
          switch (isParent) {
            case "Flevel":
              this.question.metas = this.question.metas.filter((val, i) => i !== index);
              break;
            case "Slevel":
              this.question.metas[index].children = this.question.metas[index].children.filter(
                (item, key) => key !== childrenKey
              );
              break;
            default:
              this.question.metas[index].children[childrenKey].children = this.question.metas[
                index
              ].children[childrenKey].children.filter((item, key) => key !== Tkey);
          }
        }
      });
      // if (isParent) {
      //   this.question.metas = this.question.metas.filter((val, i) => i !== index);
      // } else {
      //   this.question.metas[index].children = this.question.metas[index].children.filter(
      //     (item, key) => key !== childrenKey
      //   );
      // }
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    },
    // 复选框状态
    changebox() {
      this.question.score = 0;
    },
    getIdValue(arr) {
      if (arr.length === 0) return;
      arr.forEach((item) => {
        this.CollapseValue.push(item.id);
        if (item.children && item.children.length > 0) {
          this.getIdValue(item.children);
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.tableData, "tableData");
      console.log(this.data, "this.data");
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
        console.log(this.data.metas, "this.data.metas");
        this.getIdValue(this.data.metas);
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // this.$emit("data1:data", this.question);
    //   this.$nextTick(() => {
    //     this.from = this.parent.Case.basic;
    //   });
  }
};
</script>
<style lang="stylus">
.fillblank
  width 790px
  padding 24px 16px 24px 44px
  .collapseLabel
    display inline-block
    width 90px
    text-align right
  .question-stem
    position relative
    .ivu-form-item-content
      width 75%
  .checkbox
    width 100%
    height 50px
    padding-left 85px
  .explain
    width 100%
    height 100px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    resize none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
    padding 5px
</style>
